/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingdetails1Inputs */

const en_listingdetails1 = /** @type {(inputs: Listingdetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing Details`)
};

const de_listingdetails1 = /** @type {(inputs: Listingdetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details zum Ort`)
};

/**
* | output |
* | --- |
* | "Listing Details" |
*
* @param {Listingdetails1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingdetails1 = /** @type {((inputs?: Listingdetails1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingdetails1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingdetails1(inputs)
	return de_listingdetails1(inputs)
});
export { listingdetails1 as "listingDetails" }